import React,{ useState } from "react";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {
    loadingToggleAction,
    loginAction,
} from '../../store/actions/AuthActions';
import "../../css/shinewell-login.css";

function Login(props) {
	const [email, setEmail] = useState('');
    let errorsObj = { email: '', password: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [password, setPassword] = useState('');

    const dispatch = useDispatch();
	const Navigate = useNavigate();

	
   //setEmail('');
    //setPassword('123456');
    function onLogin(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'Email is Required';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is Required';
            error = true;
        }
        setErrors(errorObj);
        if (error) {
			return;
		}        
		dispatch(loadingToggleAction(true));
        dispatch(loginAction(email, password, Navigate));
    }

  return (
		<div className="shinewell-login-page">
			<div className="shinewell-card-wrapper">
				<div className="shinewell-corner top-left"></div>
				<div className="shinewell-corner top-right"></div>
				<div className="shinewell-corner bottom-left"></div>
				<div className="shinewell-corner bottom-right"></div>

				<div className="shinewell-card">
					{/* Shinewell Brand Header */}
					<div className="shinewell-brand-header">
						<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 2L14.2 9.8L21 12L14.2 14.2L12 21L9.8 14.2L3 12L9.8 9.8L12 2Z" fill="#FF4D12"/>
							<circle cx="5" cy="5" r="1.5" fill="#FF4D12"/>
							<circle cx="19" cy="5" r="1.5" fill="#FF4D12"/>
							<circle cx="19" cy="19" r="1.5" fill="#FF4D12"/>
							<circle cx="5" cy="19" r="1.5" fill="#FF4D12"/>
						</svg>
						<span className="shinewell-brand-name">
							SHINEWELL<span className="shinewell-brand-dot"></span>
						</span>
					</div>

					{/* Title and Subtitle */}
					<h2 className="shinewell-title">Welcome to Payroll Software</h2>
					<p className="shinewell-subtitle">Sign in by entering information below</p>

					{/* Alert messages */}
					{props.errorMessage && (
						<div className='text-danger text-center mb-3 fs-14'>
							{props.errorMessage}
						</div>
					)}
					{props.successMessage && (
						<div className='bg-green-300 text-green-900 border border-green-900 p-2 mb-3 rounded text-center fs-14'>
							{props.successMessage}
						</div>
					)}

					{/* Login Form */}
					<form onSubmit={onLogin}>
						<div className="form-group mb-3">
							<div className="shinewell-label-row">
								<label className="shinewell-label-text">Email</label>
								<span className="shinewell-label-tech">USER_ID // EMAIL</span>
							</div>
							<input
								type="text"
								className="form-control shinewell-input-field"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="name@example.com"
							/>
							{errors.email && <div className="text-danger fs-12 mt-1">{errors.email}</div>}
						</div>

						<div className="form-group mb-3">
							<div className="shinewell-label-row">
								<label className="shinewell-label-text">Password</label>
								<span className="shinewell-label-tech">KEY // PASSWORD</span>
							</div>
							<input
								type="password"
								className="form-control shinewell-input-field"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder="••••••••"
							/>
							{errors.password && <div className="text-danger fs-12 mt-1">{errors.password}</div>}
						</div>

						<div className="shinewell-checkbox-row">
							<input
								type="checkbox"
								className="shinewell-checkbox"
								id="basic_checkbox_1"
							/>
							<label className="shinewell-checkbox-label" htmlFor="basic_checkbox_1">
								Remember my preference
							</label>
						</div>

						<button type="submit" className="btn shinewell-btn-submit">
							Sign In
						</button>
					</form>
				</div>
			</div>

			{/* Footer */}
			<div className="shinewell-footer">
				<span className="shinewell-footer-text">
					SHINEWELL SOFTTECH &nbsp;•&nbsp; © 2026 SHINEWELL &nbsp;•&nbsp; PRIVACY POLICY
				</span>
			</div>
		</div>
  );
};

const mapStateToProps = (state) => {
	console.log('state');
	console.log(state);
    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
    };
};
export default connect(mapStateToProps)(Login);

